import React from 'react';
import EditarSectores from '../../../components/insumos/sectores/EditarSectores';

const InsumosEditarPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Editar Sectores</h1>
      <br />
      <br />
      <EditarSectores />
    </div>
  );
};

export default InsumosEditarPage;